import { useEffect } from "react"

export default function useAutoPlayShort(videoRefs, currentIndex) {
  useEffect(() => {
    if (!videoRefs.current?.length) return

    videoRefs.current.forEach((video, idx) => {
      if (!video || !video.pause) return

      if (idx === currentIndex) {
        const playPromise = video.play?.()
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {})
        }
      } else {
        video.pause()
      }
    })
  }, [currentIndex, videoRefs])

  useEffect(() => {
    // preload video kế tiếp
    const nextVideo = videoRefs.current?.[currentIndex + 1]
    if (nextVideo && nextVideo.preload !== "auto") {
      nextVideo.preload = "auto"
      nextVideo.load?.()
    }
  }, [currentIndex, videoRefs])
}
